import axios from 'axios'
import library from '../../../utils/Library'

export const getAppVersionRTEnviroments = async (appCode, appPlatformCode, includeDeprecated = false) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = `${library.getBaseAPIUrl(
    'version_enviroments'
  )}/getAppVersionRTEnviroments`

  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: {
      appCode,
      appPlatformCode,
      includeDeprecated
    }
  })
}
